import { Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CommonExternalModule } from '../../common/common-external-module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WebOrderLocationSetup } from '../../Model/web-order-location-setup';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastService } from '../../services/toast.service';
import { Subscription } from 'rxjs';
import { ContactService } from '../../services/contact.service';
import { WebUserInfo } from '../../data/web-user-info';
import { LocalStorageService } from '../../services/local-storage.service';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { ProductDeliveryAddressComponent } from '../../pages/product-delivery-address/product-delivery-address.component';
import { ProductService } from '../../services/product.service';
import { OrderSummary } from '../../Model/order-summary';
import { ProductOrderSummaryServiceService } from '../../services/product-order-summary-service.service';
import { Product } from '../../Model/product';
import { Router } from '@angular/router';
import { getWindow } from 'ssr-window';
import { AddressService } from '../../services/address.service';
import { State } from '../../Model/state';
import { NameWithIdDto } from '../../Model/name-with-id-dto';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { CustomerDeliveryAddress } from '../../Model/customer-delivery-address';
import { ProductOrderSummary } from '../../Model/product-order-summary';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { GstSaleInvCumBosDto } from '../../Model/gst-sale-inv-cum-bos-dto';

@Component({
  selector: 'app-store-pickup-dialog',
  standalone: true,
  imports: [CommonExternalModule],
  templateUrl: './store-pickup-dialog.component.html',
  styleUrl: './store-pickup-dialog.component.css'
})
export class StorePickupDialogComponent implements OnInit, OnDestroy {

  currentUrl: string;
  selectedOption: string = '';
  url: string;

  createSetUpForm: UntypedFormGroup;
  pincode: number;
  locationSetupList: WebOrderLocationSetup[] = [];
  orderSummary: OrderSummary = new OrderSummary();
  availableOptions = ['delivery'];

  showToast: boolean = false;
  showClickButton: boolean = true;
  showSubmitBtn: boolean = false;
  selectedIndex: number = null;

  //For Google Map
  searchInput: string = '';
  newDeliveryDetails: boolean = true;
  latitudeMap: number;
  longitudeMap: number;
  zoom: number = 10;

  addressMap: string;
  private geoCoder;
  private googleMapInitialized = false;
  @ViewChild("search") public searchElementRef: ElementRef;

  center: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.2090 };
  markerPosition: google.maps.LatLngLiteral = { lat: 28.6139, lng: 77.2090 };
  markerOptions: google.maps.MarkerOptions = {
    draggable: true
  };

  private onLocationDetailsSubscription: Subscription;
  private saveWebUserInfoSubscription: Subscription;
  private onDeliveryLocClickSubscription: Subscription;
  private stateSubcription: Subscription;
  private districtListSubscription: Subscription;
  private getDeliveryDetailsSubscription: Subscription;
  private cityListSubscription: Subscription;
  private customerDeliveryDetailsSubcription: Subscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<StorePickupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private localStorage: LocalStorageService,
    private apiFactory: ApiFactoryEndPoints,
    private toastService: ToastService,
    // private productService: ProductService,
    private navRoute: Router,
    // private commonService: CommonService,
    private contactService: ContactService,
    // public dialog: MatDialog,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private productService: ProductService,
    private productOrderSummaryService: ProductOrderSummaryServiceService,
    private addressService: AddressService
  ) {
    if (dialogData && dialogData.type) {
      this.selectedOption = dialogData.type;
    }
  }

  ngOnInit(): void {
    // this.url = getWindow().location.hostname;
    this.url = window.location.host.replace(':', '');
    this.currentUrl = this.navRoute.url.replace("/", "");
    // this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    // this.deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    this.availableOptions = ['delivery']; // Set available options based on your conditions

    // Check if only one option is available
    if (this.availableOptions.length === 1 && !this.selectedOption) {
      this.selectedOption = this.availableOptions[0];
    }
    // // this.storeLocation = JSON.parse(this.localStorage.getItem("pickup_location"));
    // this.setCurrentLocationStore();
    // // this.getStoreLocationList();
    this.onCreateSetUp();
    this.onCreateSetUpDelivery();
    this.getWebOrders();
    this.getWebOrdersArray();
    this.getStateList();
  }

  ngAfterViewInit(): void {
    console.log(this.selectedOption)
    if (this.selectedOption === 'delivery') {
      this.initMapIfNeeded();
      // this.setCurrentLocation();
    }
  }

  ngOnDestroy(): void {

  }

  onCreateSetUp() {
    this.createSetUpForm = this.formBuilder.group({
      pincode: ["", [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")],],
    });
  }

  initMapIfNeeded(): void {
    console.log(this.googleMapInitialized)
    console.log(this.searchElementRef)
    if (!this.googleMapInitialized && this.searchElementRef) {
      this.getGoogleMap();
      this.googleMapInitialized = true;
    }
  }

  //Map
  // getGoogleMap() {
  //   this.mapsAPILoader.load().then(() => {
  //     this.setCurrentLocationPin();
  //     this.geoCoder = new google.maps.Geocoder();

  //     const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
  //     autocomplete.addListener("place_changed", () => {
  //       this.ngZone.run(() => {
  //         const place = autocomplete.getPlace();
  //         if (!place.geometry) return;

  //         this.latitudeMap = place.geometry.location.lat();
  //         this.longitudeMap = place.geometry.location.lng();
  //         this.zoom = 12;

  //         this.getAddress(this.latitudeMap, this.longitudeMap);
  //       });
  //     });
  //   });
  // }

  getGoogleMap() {
    this.setCurrentLocationPin();
    this.geoCoder = new google.maps.Geocoder();

    const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    autocomplete.addListener('place_changed', () => {

      setTimeout(() => {
        const input = this.searchElementRef.nativeElement;
        const pac = document.querySelector('.pac-container') as HTMLElement;

        if (pac) {
          pac.style.width = `${input.getBoundingClientRect().width}px`;
        }
      });

      this.ngZone.run(() => {
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
          return;
        }

        this.latitudeMap = place.geometry.location.lat();
        this.longitudeMap = place.geometry.location.lng();
        this.zoom = 15;

        this.center = {
          lat: this.latitudeMap,
          lng: this.longitudeMap
        };

        this.markerPosition = {
          lat: this.latitudeMap,
          lng: this.longitudeMap
        };


        this.getAddress(this.latitudeMap, this.longitudeMap);
      });
    });
  }

  private setCurrentLocationPin() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitudeMap = position.coords.latitude;
        this.longitudeMap = position.coords.longitude;
        this.zoom = 12;
        // this.getAddress(this.latitudeMap, this.longitudeMap);
      });
    }
  }

  setCurrentLocation() {

    if (!navigator.geolocation) {
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (position) => {

        navigator.geolocation.clearWatch(watchId);

        this.ngZone.run(() => {

          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.markerPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.zoom = 12;
        });

      },
      (error) => console.error(error),
      {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0
      }
    );
  }

  stateName: string;
  districtName: string;
  cityName: string;

  getAddress(latitude: number, longitude: number) {
    this.toastService.clearAllToast();
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === "OK" && results[0]) {
        this.zoom = 12;
        this.addressMap = results[0].formatted_address;

        const addressComponents = results[0].address_components;
        console.log(addressComponents);
        const pincodeComponent = addressComponents.find(c => c.types.includes('postal_code'));
        console.log(pincodeComponent);

        const stateComponent = addressComponents.find(c => c.types.includes('administrative_area_level_1'));
        this.stateName = stateComponent.long_name;

        const districtComponent = addressComponents.find(c => c.types.includes('administrative_area_level_3'));
        console.log(districtComponent)
        this.districtName = districtComponent.long_name;

        const cityComponent = addressComponents.find(c => c.types.includes('locality'));
        console.log(cityComponent)
        this.cityName = cityComponent.long_name;

        if (pincodeComponent) {
          this.pincode = pincodeComponent.long_name;
          this.createSetUpForm.patchValue({ pincode: this.pincode });
          this.choosePincode();
        } else {
          this.toastService.showErrorToast("Pincode not found.");
          this.clearSearch();
        }
      } else {
        this.toastService.showErrorToast("Geocoder failed due to: " + status);
      }
    });
  }

  choosePincode() {
    this.pincode = this.createSetUpForm.get("pincode").value;
    this.showToast = false;

    if (this.pincode.toString().length === 6) {
      this.onLocationDetailsSubscription = this.contactService.getLocationDetailsByPincodeAndlatlng(this.pincode, this.url, this.latitudeMap, this.longitudeMap).subscribe((data) => {
        console.log(data);
        if (data.length > 0) {
          this.showClickButton = false;
          this.showSubmitBtn = true;
          this.showToast = false;
          this.locationSetupList = data;

          this.locationSetupList.forEach((element) => {
            if (element.address.length > 40) {
              let firstAdd: string = "";
              const adds = element.address.split(",");
              if (adds.length > 0) {
                for (let i = 0; i < adds.length; i++) {
                  if (firstAdd.length + adds[i].length < 40) {
                    firstAdd += adds[i] + ", ";
                  }
                }
              }
              if (firstAdd.length > 0) {
                element.address1 = firstAdd;
                element.address2 = element.address.substring(
                  firstAdd.length - 1,
                  element.address.length
                );
              }
            } else {
              element.address1 = element.address;
            }
          });
          if (this.locationSetupList.length == 1) {
            this.onSelectLocation(0);
          }
        } else {
          this.showClickButton = true;
          this.showToast = true;
          this.locationSetupList = [];
          this.selectedIndex = null;
          this.saveWebUserInfo();
        }
      });
    }
  }

  saveWebUserInfo() {
    const localWebUserInfo: WebUserInfo = JSON.parse(this.localStorage.getItem("web_user_info"));
    const blockedIps = ['182.79.71.219', '182.79.71.218'];
    if (localWebUserInfo && localWebUserInfo.clientIp && !blockedIps.includes(localWebUserInfo.clientIp)) {
      localWebUserInfo.searchedPinCodeArea = this.pincode.toString();

      this.saveWebUserInfoSubscription = this.contactService.saveWebUserInfo(this.apiFactory.insertWebUserInfo, localWebUserInfo).subscribe((data) => {
        if (data) {
        }
      });
    }
  }

  onSearchInput(value: string) {
    this.searchInput = value;
  }

  clearSearch() {
    this.searchInput = '';
    if (this.searchElementRef?.nativeElement) {
      this.searchElementRef.nativeElement.value = '';
    }
    this.locationSetupList = [];
    this.showToast = false;
    this.showClickButton = true;
    this.googleMapInitialized = false;
  }

  fetchCurrentLoc() {
    if (!("geolocation" in navigator)) {
      this.toastService.showErrorToast("Geolocation not supported");
      return;
    }

    this.toastService.showWarningToast("Fetching current location...");

    let watchId = navigator.geolocation.watchPosition(
      (position) => {
        console.log("Live location fetched: ", position);

        this.latitudeMap = position.coords.latitude;
        this.longitudeMap = position.coords.longitude;
        this.zoom = 12;

        this.createSetUpForm.patchValue({
          latitude: this.latitudeMap,
          longitude: this.longitudeMap,
        });

        this.getAddress(this.latitudeMap, this.longitudeMap);

        // Stop watching after first successful fetch
        navigator.geolocation.clearWatch(watchId);
      },
      (error) => {
        console.error("Geolocation error: ", error);
        let message = "";

        switch (error.code) {
          case error.PERMISSION_DENIED:
            message = "Permission denied. Enable location.";
            break;
          case error.POSITION_UNAVAILABLE:
            message = "Location unavailable. Try again.";
            break;
          case error.TIMEOUT:
            message = "Request timed out.";
            break;
          default:
            message = "Unknown location error.";
        }

        this.toastService.showErrorToast(message);
        navigator.geolocation.clearWatch(watchId);
      },
      {
        enableHighAccuracy: true,
        timeout: 20000,
        maximumAge: 0
      }
    );
  }

  markerDragEnd(event: any) {
    this.latitudeMap = event.latLng.lat();
    this.longitudeMap = event.latLng.lng();
    this.getAddress(this.latitudeMap, this.longitudeMap);

    this.createSetUpForm.patchValue({
      latitude: this.latitudeMap,
      longitude: this.longitudeMap,
    });
  }

  onSelectLocation(index: number) {
    this.selectedIndex = index;
  }

  onContinueClick(selectedOption: string) {
    if (selectedOption == 'storePickup') {
      // if (!this.storeLocation) {
      //   this.toastService.showErrorToast('Select Location');
      //   return;
      // }

      // this.localStorage.setItem("delivery_type", JSON.stringify(selectedOption));
      // this.localStorage.setItem("location_code", JSON.stringify(this.storeLocation.locationCode));
      // this.localStorage.setItem("company_code", JSON.stringify(this.storeLocation.companyCode));
      // this.localStorage.setItem("state_code", JSON.stringify(this.storeLocation.stateCode));
      // this.localStorage.setItem("min_selflife", JSON.stringify(this.storeLocation.minSelfLife));
      // this.localStorage.setItem("parent_location_code", JSON.stringify(this.storeLocation.parentLocationCode));
      // this.localStorage.setItem("pickup_location", JSON.stringify(this.storeLocation));

      // this.clearSearch();
      // this.dialogRef.close('storePickup');
    } else if (selectedOption == 'delivery') {
      this.onDeliveryLocClick(this.locationSetupList[this.selectedIndex]);
      // this.dialogRef.close('delivery');
      // this.storeLocation = null;
    } else {
      this.toastService.showSuccessToast("Pickup or Delivery");
    }
  }

  onDeliveryLocClick(locData: WebOrderLocationSetup) {
    console.log(locData);
    if (!locData || !this.latitudeMap || !this.longitudeMap || !this.pincode) {
      this.toastService.showErrorToast("Please select a valid location");
      return;
    }

    this.selectedLocation = locData;
    this.storeLocationData(locData);

    this.pincode = this.createSetUpForm.get("pincode").value;
    this.onDeliveryLocClickSubscription = this.productService.checkPincode(this.apiFactory.checkPincode, locData.pincode, this.url)
      .subscribe(async (isValidPincode) => {
        if (isValidPincode) {
          this.handleValidPincode(locData);
          this.showDeliveryDetails = true;
          const stored = this.localStorage.getDeliveryDetails();
          console.log("Stored delivery details:", stored);

          if (stored) {

            const state = this.stateList.find(e => e.stateName === stored.stateName);

            if (!state) {
              return;
            }

            // Load districts
            this.onStateSelect(state.refNo);

            await this.waitFor(() => this.districtList.length > 0);

            const district = this.districtList.find(
              e => e.name === stored.districtName
            );

            if (!district) {
              return;
            }

            // Load cities
            this.onDistrictSelect(district.id);

            await this.waitFor(() => this.cityList.length > 0);

            const city = this.cityList.find(
              e => e.name === stored.cityName
            );
            console.log(city)

            this.createSetUpFormDelivery.patchValue({
              pincode: stored.pincode,
              latitude: stored.latitude,
              longitude: stored.longitude,
              stateCode: state.refNo,
              districtCode: district.id,
              cityCode: city?.id
            });

            this.latitudeMap = stored.latitude;
            this.longitudeMap = stored.longitude;
            this.deliveryPinCode = stored.pincode;
          }

          // if (stored) {
          //   this.createSetUpFormDelivery.patchValue({
          //     pincode: stored.pincode,
          //     latitude: stored.latitude,
          //     longitude: stored.longitude,
          //     stateCode: this.stateList.find(e => e.stateName === stored.stateName).refNo,
          //     districtCode: this.districtList.find(e => e.name === stored.districtName).id,
          //     cityName: this.cityList.find(e => e.name === stored.cityName).id
          //   });

          //   this.latitudeMap = stored.latitude;
          //   this.longitudeMap = stored.longitude;
          //   this.deliveryPinCode = stored.pincode;
          // }

          // Step 3: Load delivery addresses
          this.getDeliveryDetails();
          // if (this.dialogRef.componentInstance) {
          //   // Scroll the dialog content to top
          //   const dialogContent = document.querySelector('.dialog-content');
          //   if (dialogContent) {
          //     dialogContent.scrollTop = 0;
          //   }
          // }
        } else {
          this.toastService.showErrorToast("Invalid Pincode");
          this.createSetUpForm.patchValue({ pincode: "" });
        }
      });
  }

  private waitFor(condition: () => boolean, interval = 100): Promise<void> {
    return new Promise((resolve) => {
      const timer = setInterval(() => {
        if (condition()) {
          clearInterval(timer);
          resolve();
        }
      }, interval);
    });
  }

  private storeLocationData(locData: WebOrderLocationSetup) {
    this.localStorage.setItem("location_code", JSON.stringify(locData.locationCode));
    this.localStorage.setItem("state_code", JSON.stringify(locData.stateCode));
    this.localStorage.setItem("company_code", JSON.stringify(locData.companyCode));
    this.localStorage.setItem("parent_location_code", JSON.stringify(locData.parentLocationCode));
    this.localStorage.setItem("delivery_location", JSON.stringify(locData));
  }

  private handleValidPincode(locData: WebOrderLocationSetup) {
    // Remove old pincode & minSelfLife data from localStorage
    this.localStorage.removeItem("pincode_item");
    this.localStorage.removeItem("min_selflife");

    // Update order summary
    this.orderSummary.pincode = locData.pincode;
    this.orderSummary.product = this.dialogData?.productValue;
    this.productService.setOrderSummary(this.orderSummary);
    this.productService.setPincode(locData.pincode);

    // Save new pincode & minSelfLife data to localStorage
    this.localStorage.setItem("delivery_type", JSON.stringify('delivery'));
    this.localStorage.setItem("pincode_item", JSON.stringify(locData.pincode));
    this.localStorage.setItem("min_selflife", JSON.stringify(locData.minSelfLife));
    this.localStorage.setDeliveryDetails({
      pincode: this.pincode,
      latitude: this.latitudeMap,
      longitude: this.longitudeMap,
      stateName: this.stateName,
      districtName: this.districtName,
      cityName: this.cityName
    });


    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];

    // if (cartProducts.length > 0) {
    //   this.dialogRef.close('delivery');
    // } else {
    //   this.navRoute.navigate([this.currentUrl]);
    //   this.dialogRef.close('delivery');
    // }
  }

  showDeliveryDetails = false;
  selectedLocation: any = null;

  onEditLocation(): void {
    // Hide delivery details and show the selection interface
    this.showDeliveryDetails = false;
    this.selectedLocation = null;
    // Optionally reset selection
    this.selectedIndex = -1;
    this.selectedOption = 'delivery';
    this.locationSetupList = [];
    this.clearSearch();
    setTimeout(() => {
      this.initMapIfNeeded();
    });
    this.deliveryDetailsList = [];
  }

  onConfirmDelivery(): void {
    if (this.selectedLocation) {
      // Handle final confirmation
      this.dialogRef.close({
        confirmed: true,
        location: this.selectedLocation
      });
    }
  }

  createSetUpFormDelivery: UntypedFormGroup;

  onCreateSetUpDelivery() {
    this.createSetUpFormDelivery = this.formBuilder.group({
      id: [""],
      customerName: ["", Validators.required],
      contactNo: ["", [Validators.required, Validators.pattern("[6-9]\\d{9}")]],
      email: [""],
      // email: ["", Validators.compose([Validators.required,Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/),]),],
      deliveryDate: [""],
      deliveryTime: [""],
      plotNo: ["", Validators.required],
      street: ["", Validators.required],
      landMark: [""],
      pincode: ["", [Validators.required, Validators.pattern("^[1-9][0-9]{5}$")],],
      cityCode: ["", Validators.required],
      stateCode: ["", Validators.required],
      districtCode: ["", Validators.required],
      address: ["", Validators.required],
      logInCustomerEmail: [""],
      defaultAddress: [""],
      latitude: ["", Validators.required],
      longitude: ["", Validators.required],
    });
  }

  stateList: State[] = [];

  getStateList() {
    this.stateSubcription = this.addressService.getStateList().subscribe((data) => {
      this.stateList = data.filter(state => state.stateName === 'Odisha');
      if (this.stateList.length == 1) {
        this.createSetUpFormDelivery.get('stateCode').setValue(this.stateList[0].refNo);
        this.onStateSelect(this.stateList[0].refNo);
      }
    });
  }

  districtList: NameWithIdDto[] = [];

  onStateSelect(stateCode: number) {
    this.districtListSubscription = this.addressService.getDistrictByStateCode(this.apiFactory.getDistrictListByStateCode, stateCode).subscribe((data) => {
      this.districtList = data;
    });
  }

  googleCustomer: GoogleCustomer;
  deliveryDetailsList: any[] = [];

  get deliveryListWithAddOption() {
    return [...this.deliveryDetailsList, { isNew: true }];
  }

  deliveryPinCode: number;

  getDeliveryDetails() {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.deliveryPinCode = JSON.parse(this.localStorage.getItem("pincode_item"));

    // this.createSetUpForm.get('pincode').setValue(this.deliveryPinCode);

    const stored = JSON.parse(this.localStorage.getItem('last_delivery_address')); // 🔁 get again here

    if (this.googleCustomer?.email != null) {
      this.getDeliveryDetailsSubscription = this.addressService
        .getDeliveryDetails(this.apiFactory.getDeliveryDetailsByCustomerCode, this.googleCustomer.refNo, this.deliveryPinCode.toString())
        .subscribe((data) => {
          if (data.length > 0) {
            this.deliveryDetailsList = data;
            // this.showDeliveryDiv = true;
            this.deliveryListWithAddOption;

            if (stored) {
              console.log("Stored Delivery Details:", stored);

              data.forEach((item, index) => {
                // console.log(`Checking item at index ${index}`);
                // console.log('Item.latitude:', Number(item.latitude), 'Stored.latitude:', Number(stored.latitude));
                // console.log('Item.longitude:', Number(item.longitude), 'Stored.longitude:', Number(stored.longitude));
                // console.log('Item.shippingPinCode:', Number(item.shippingPinCode), 'Stored.pincode:', Number(stored.pincode));

                const latMatch = Number(item.latitude) === Number(stored.latitude);
                const lngMatch = Number(item.longitude) === Number(stored.longitude);
                const pinMatch = Number(item.shippingPinCode) === Number(stored.pincode);

                // console.log(`Match status -> lat: ${latMatch}, lng: ${lngMatch}, pin: ${pinMatch}`);
              });

              const matchedIndex = data.findIndex(item =>
                Number(item.refNo) === Number(stored.refNo)
              );

              console.log("Matched Index:", matchedIndex);

              if (matchedIndex !== -1) {
                this.onDeliveryDetailsClick(data[matchedIndex], matchedIndex);
              }
            }


          } else {
            // this.showDeliveryDiv = false;
          }
        });
    }
  }

  toogle: number;

  onDeliveryDetailsClick(deliveryDetail: any, index: number) {
    if (deliveryDetail.isNew) {
      this.toogle = index;
      this.createSetUpFormDelivery.reset();
      this.createSetUpFormDelivery.enable(); // enable for new entry
      // this.createSetUpFormDelivery.get('pincode').setValue(this.deliveryPinCode);
      return;
    }

    if (index === this.toogle) {
      this.toogle = null;
      this.createSetUpFormDelivery.reset();
      // this.createSetUpForm.get('pincode').setValue(this.deliveryPinCode);
      this.createSetUpForm.enable();
    } else {
      this.toogle = index;
      // this.onStateSelect(deliveryDetail.shippingCity?.district?.state?.refNo);
      // this.onDistrictSelect(deliveryDetail.shippingCity?.district?.refNo);
      console.log(deliveryDetail)
      this.createSetUpFormDelivery.patchValue({
        id: deliveryDetail.refNo,
        customerName: deliveryDetail.contactName,
        contactNo: deliveryDetail.contactMobile,
        email: this.googleCustomer.email,
        // deliveryDate: moment(deliveryDateTime).format("YYYY-MM-DD"),
        // deliveryTime: moment(deliveryDateTime).format("hh:mm a"),
        plotNo: deliveryDetail.shippingPlotNo,
        areaLocality: deliveryDetail.areaLocality,
        pincode: deliveryDetail.shippingPinCode,
        cityCode: deliveryDetail.shippingCityCode,
        stateCode: deliveryDetail.shippingCity?.district?.state?.refNo,
        districtCode: deliveryDetail.shippingCity?.district?.refNo,
        address: deliveryDetail.shippingAddress,
        street: deliveryDetail.shippingStreet,
        landMark: deliveryDetail.shippingLandMark,
        latitude: deliveryDetail.latitude,
        longitude: deliveryDetail.longitude,
        logInCustomerEmail: this.googleCustomer.email,
        defaultAddress: deliveryDetail.defaultAddress,
      });
      this.latitudeMap = deliveryDetail.latitude;
      this.longitudeMap = deliveryDetail.longitude;
      this.zoom = 2;
      this.getAddress(Number(this.latitudeMap), Number(this.longitudeMap));
      this.createSetUpFormDelivery.disable(); // make existing data non-editable
    }
  }

  cityList: NameWithIdDto[] = [];

  onDistrictSelect(districtCode: number) {
    this.cityListSubscription = this.addressService.getCitysByDistrictCode(this.apiFactory.getCityListByDistrictCode, districtCode).subscribe((data) => {
      this.cityList = data;
    });
  }

  mapOptions: google.maps.MapOptions;

  onMarkerDrag(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.markerPosition = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
      this.latitudeMap = event.latLng.lat();
      this.longitudeMap = event.latLng.lng();
      this.createSetUpFormDelivery.patchValue({
        latitude: event.latLng.lat(),
        longitude: event.latLng.lng(),
      });
      this.getAddressDelivery(this.latitudeMap, this.longitudeMap);
    }
  }

  getAddressDelivery(latitude, longitude) {
    /* 🔥 Always sync map */
    this.center = { lat: latitude, lng: longitude };
    this.markerPosition = { lat: latitude, lng: longitude };

    this.toastService.clearAllToast();
    console.log(this.geoCoder)
    this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === "OK") {
        if (results[0]) {
          this.zoom = 12;
          this.addressMap = results[0].formatted_address;

          const addressComponents = results[0].address_components;
          let pincode = '';

          // Check if pincode is present
          const hasPincode = addressComponents.some(comp => comp.types.includes('postal_code'));
          if (!hasPincode) {
            this.resetMapFields('Your location does not have a valid pincode.');
            return;
          }

          // Extract Pincode
          for (const component of addressComponents) {
            if (component.types.includes('postal_code')) {
              pincode = component.long_name;
              console.log('deliveryPinCode:', this.deliveryPinCode);
              console.log('Extracted pincode:', pincode);
              if (String(pincode) !== String(this.deliveryPinCode)) {
                this.resetMapFields('Your location does not match the PIN: ' + this.deliveryPinCode);
                return;
              }
              break;
            }
          }

          // const deliveryPinCode = this.createSetUpForm.get("pincode").value;
          // console.log('Delivery PIN:', deliveryPinCode);
          // console.log('Extracted PIN:', pincode);
          // // If no pincode exists in address
          // if (!pincode) {
          //   this.resetMapFields('Your location does not have a valid pincode.');
          //   return;
          // }

          // // If delivery pincode is empty, use extracted pincode
          // if (!deliveryPinCode) {
          //   this.createSetUpForm.patchValue({
          //     pincode: pincode
          //   });

          //   this.choosePincode(pincode);
          //   return;
          // }

          // // Existing validation
          // if (String(pincode) !== String(deliveryPinCode)) {
          //   this.resetMapFields('Your location does not match the PIN: ' + deliveryPinCode);
          //   return;
          // }
        } else {
          this.toastService.showErrorToast("No results found");
        }
      } else {
        this.toastService.showErrorToast("Geocoder failed due to: " + status);
      }
    });
  }

  resetMapFields(message: string) {
    this.createSetUpFormDelivery.get("latitude").reset();
    this.createSetUpFormDelivery.get("longitude").reset();
    this.toastService.showErrorToast(message);
  }

  productOrderSummary: ProductOrderSummary = new ProductOrderSummary();

  deliveryDate: Date;
  deliveryTime: string;

  onCreateSetUpClick() {
    console.log(this.createSetUpFormDelivery);
    // if (!this.isPincodeValid) {
    //   this.toastService.showErrorToast("Selected address is not serviceable.");
    //   return;
    // }
    if (this.createSetUpFormDelivery.invalid) {
      this.toastService.showErrorToast("Invalid form");
      return;
    }
    if (this.createSetUpFormDelivery.get("pincode").value != this.deliveryPinCode) {
      this.toastService.showErrorToast('Delivery available to this pincode ' + this.deliveryPinCode);
      return;
    }

    // this.refNo = this.createSetUpForm.get("id").value;
    // this.customerName = this.createSetUpForm.get("customerName").value;
    // this.contactNo = this.createSetUpForm.get("contactNo").value;
    // this.pincode = this.createSetUpForm.get("pincode").value;
    // this.cityCode = this.createSetUpForm.get("cityCode").value;
    // this.stateId = this.createSetUpForm.get("stateCode").value;
    // this.districtId = this.createSetUpForm.get("districtCode").value;
    // this.address = this.createSetUpForm.get("address").value;
    // this.email = this.createSetUpForm.get("email").value;
    // this.plot = this.createSetUpForm.get("plotNo").value;
    // this.street = this.createSetUpForm.get("street").value;
    // this.landMark = this.createSetUpForm.get("landMark").value;
    // this.latitude = this.createSetUpForm.get("latitude").value;
    // this.longitude = this.createSetUpForm.get("longitude").value;
    // this.stateName = this.stateList.filter(e => e.refNo == this.stateId)[0]?.stateName;
    // this.cityName = this.cityList.filter(e => e.id == this.cityCode)[0]?.name;

    //For indivisual order
    // if (this.gstSaleInvcumBOS && this.gstSaleInvcumBOS.details.length != 0) {
    // this.gstSaleInvcumBOS.details.forEach((d) => {
    //   this.deliveryDate = new Date(d.deliveryDate);
    //   this.deliveryTime = d.deliveryTime;
    // });

    // this.deliveryDate.setHours(Number.parseInt(this.deliveryTime.split(":")[0]));
    // this.deliveryDate.setMinutes(Number.parseInt(this.deliveryTime.split(":")[1]));

    var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();

    deliveryAddress.refNo = this.createSetUpFormDelivery.get("id").value;
    deliveryAddress.contactName = this.createSetUpFormDelivery.get("customerName").value;
    deliveryAddress.contactMobile = this.createSetUpFormDelivery.get("contactNo").value;
    deliveryAddress.shippingPinCode = this.createSetUpFormDelivery.get("pincode").value;
    deliveryAddress.shippingCityCode = this.createSetUpFormDelivery.get("cityCode").value;
    deliveryAddress.shippingAddress = this.createSetUpFormDelivery.get("address").value;
    deliveryAddress.shippingPlotNo = this.createSetUpFormDelivery.get("plotNo").value;
    deliveryAddress.shippingLandMark = this.createSetUpFormDelivery.get("landMark").value;
    deliveryAddress.shippingStreet = this.createSetUpFormDelivery.get("street").value;
    deliveryAddress.email = this.createSetUpFormDelivery.get("email").value;
    deliveryAddress.stateCode = this.createSetUpFormDelivery.get("stateCode").value;
    deliveryAddress.districtCode = this.createSetUpFormDelivery.get("districtCode").value;
    deliveryAddress.deliveryDate = this.deliveryDate;
    deliveryAddress.latitude = this.createSetUpFormDelivery.get("latitude").value;
    deliveryAddress.longitude = this.createSetUpFormDelivery.get("longitude").value;
    deliveryAddress.stateName = this.stateList.filter(e => e.refNo == this.createSetUpFormDelivery.get("stateCode").value)[0]?.stateName;
    deliveryAddress.cityName = this.cityList.filter(e => e.id == this.createSetUpFormDelivery.get("cityCode").value)[0]?.name;;
    deliveryAddress.customerCode = this.googleCustomer.refNo;

    this.productOrderSummaryService.setCustomerDeliveryAddress(deliveryAddress);
    // this.gstSaleInvcumBOS.customerDeliveryAddress = deliveryAddress;
    this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);
    this.productOrderSummary.deliveryAddress = deliveryAddress;
    console.log(this.productOrderSummary.deliveryAddress)
    this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
    this.localStorage.setItem("customer_delivery_aaddress", JSON.stringify(deliveryAddress));

    // } else {
    //   this.deliveryDate = new Date(); // Today's date

    //   // Optional: set current time as delivery time
    //   this.deliveryTime =
    //     this.deliveryDate.getHours().toString().padStart(2, '0') +
    //     ':' +
    //     this.deliveryDate.getMinutes().toString().padStart(2, '0');
    //   var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();

    //   deliveryAddress.refNo = this.createSetUpFormDelivery.get("id").value;
    //   deliveryAddress.contactName = this.createSetUpFormDelivery.get("customerName").value;
    //   deliveryAddress.contactMobile = this.createSetUpFormDelivery.get("contactNo").value;
    //   deliveryAddress.shippingPinCode = this.createSetUpFormDelivery.get("pincode").value;
    //   deliveryAddress.shippingCityCode = this.createSetUpFormDelivery.get("cityCode").value;
    //   deliveryAddress.shippingAddress = this.createSetUpFormDelivery.get("address").value;
    //   deliveryAddress.shippingPlotNo = this.createSetUpFormDelivery.get("plotNo").value;
    //   deliveryAddress.shippingLandMark = this.createSetUpFormDelivery.get("landMark").value;
    //   deliveryAddress.shippingStreet = this.createSetUpFormDelivery.get("street").value;
    //   deliveryAddress.email = this.createSetUpFormDelivery.get("email").value;
    //   deliveryAddress.stateCode = this.createSetUpFormDelivery.get("stateCode").value;
    //   deliveryAddress.districtCode = this.createSetUpFormDelivery.get("districtCode").value;
    //   deliveryAddress.deliveryDate = this.deliveryDate;
    //   deliveryAddress.latitude = this.createSetUpFormDelivery.get("latitude").value;
    //   deliveryAddress.longitude = this.createSetUpFormDelivery.get("longitude").value;
    //   deliveryAddress.stateName = this.stateList.filter(e => e.refNo == this.createSetUpFormDelivery.get("stateCode").value)[0]?.stateName;
    //   deliveryAddress.cityName = this.cityList.filter(e => e.id == this.createSetUpFormDelivery.get("cityCode").value)[0]?.name;;
    //   deliveryAddress.customerCode = this.googleCustomer.refNo;

    //   this.productOrderSummaryService.setCustomerDeliveryAddress(deliveryAddress);
    //   // this.gstSaleInvcumBOS.customerDeliveryAddress = deliveryAddress;
    //   // this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);
    //   this.productOrderSummary.deliveryAddress = deliveryAddress;
    //   this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
    // }

    //For total order
    if (this.gstSaleInvcumBOSArray && this.gstSaleInvcumBOSArray.length != 0) {
      this.gstSaleInvcumBOSArray.forEach((e) => {
        e.details.forEach((d) => {
          this.deliveryDate = new Date(d.deliveryDate);
          this.deliveryTime = d.deliveryTime;
        });
        var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();

        deliveryAddress.refNo = this.createSetUpFormDelivery.get("id").value;
        deliveryAddress.contactName = this.createSetUpFormDelivery.get("customerName").value;
        deliveryAddress.contactMobile = this.createSetUpFormDelivery.get("contactNo").value;
        deliveryAddress.shippingPinCode = this.createSetUpFormDelivery.get("pincode").value;
        deliveryAddress.shippingCityCode = this.createSetUpFormDelivery.get("cityCode").value;
        deliveryAddress.shippingAddress = this.createSetUpFormDelivery.get("address").value;
        deliveryAddress.shippingPlotNo = this.createSetUpFormDelivery.get("plotNo").value;
        deliveryAddress.shippingLandMark = this.createSetUpFormDelivery.get("landMark").value;
        deliveryAddress.shippingStreet = this.createSetUpFormDelivery.get("street").value;
        deliveryAddress.email = this.createSetUpFormDelivery.get("email").value;
        deliveryAddress.stateCode = this.createSetUpFormDelivery.get("stateCode").value;
        deliveryAddress.districtCode = this.createSetUpFormDelivery.get("districtCode").value;
        deliveryAddress.deliveryDate = this.deliveryDate;
        deliveryAddress.latitude = this.createSetUpFormDelivery.get("latitude").value;
        deliveryAddress.longitude = this.createSetUpFormDelivery.get("longitude").value;
        deliveryAddress.stateName = this.stateList.filter(e => e.refNo == this.createSetUpFormDelivery.get("stateCode").value)[0]?.stateName;
        deliveryAddress.cityName = this.cityList.filter(e => e.id == this.createSetUpFormDelivery.get("cityCode").value)[0]?.name;;
        deliveryAddress.customerCode = this.googleCustomer.refNo;

        e.customerDeliveryAddress = deliveryAddress;
      });
      this.productOrderSummaryService.setWebOrderArray(this.gstSaleInvcumBOSArray);

      this.productOrderSummary.deliveryAddress = deliveryAddress;
      this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
    } else {
      this.deliveryDate = new Date(); // Today's date

      // Optional: set current time as delivery time
      this.deliveryTime =
        this.deliveryDate.getHours().toString().padStart(2, '0') +
        ':' +
        this.deliveryDate.getMinutes().toString().padStart(2, '0');

      this.productOrderSummaryService.setWebOrderArray(this.gstSaleInvcumBOSArray);

      this.productOrderSummary.deliveryAddress = deliveryAddress;
      this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
    }

    console.log(this.productOrderSummary.deliveryAddress)

    this.createSetUpForm.patchValue({ logInCustomerEmail: this.googleCustomer.email, });
    this.customerDeliveryDetailsSubcription = this.addressService.insertDeliveryDetails(this.apiFactory.insertDeliveryDetailsApp, this.productOrderSummary.deliveryAddress)
      .subscribe((data) => {
        this.productOrderSummary.deliveryAddressRefNo = data.refNo;
        this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
        // this.localStorage.setItem("last_delivery_address", JSON.stringify(this.productOrderSummary.deliveryAddress));
        this.addressService.updateLastDeliveryAddress(
          this.productOrderSummary.deliveryAddress
        );
        this.toastService.showSuccessToast("Saved Successfully");
        this.dialogRef.close('delivery');
        // this.navRoute.navigate(["/order-summary"]);
      });

    // this.dialog.open(GstinDialogComponent, {
    //   width: "350px",
    //   autoFocus: false,
    // });

    // this.webOrderMinimumDateTimeSubcription = this.addressService.getWebOrderMinimumDateTimeDetails().subscribe((data) => {
    //   this.webOrderMinimumDateTimeList = data;

    //   //function for checking deleivery duartion
    //   this.deliveryDate.setHours(
    //     Number.parseInt(this.deliveryTime.split(":")[0])
    //   );
    //   this.deliveryDate.setMinutes(
    //     Number.parseInt(this.deliveryTime.split(":")[1])
    //   );

    //   var orderDuration = new Date();
    //   orderDuration.setHours(orderDuration.getHours() + Number.parseInt(
    //     this.webOrderMinimumDateTimeList.deliveryTime.split(":")[0]));
    //   orderDuration.setMinutes(orderDuration.getMinutes() + Number.parseInt(
    //     this.webOrderMinimumDateTimeList.deliveryTime.split(":")[1]));

    //   if (orderDuration.getTime() >= this.deliveryDate.getTime()) {
    //     this.toastService.showErrorToast("Cannot place order please select Date After " +
    //       this.webOrderMinimumDateTimeList.deliveryTime.split(":")[0] + " " + "Hour");
    //   } else {
    //     var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();
    //     deliveryAddress.customerName = this.customerName;
    //     deliveryAddress.mobileNo = this.contactNo;
    //     deliveryAddress.pinCode = this.pincode;
    //     deliveryAddress.city = this.cityName;
    //     deliveryAddress.districtCode = this.districtId;
    //     deliveryAddress.houseAddress = this.address;
    //     deliveryAddress.email = this.email;
    //     deliveryAddress.deliveryDate = this.deliveryDate;
    //     console.log(this.deliveryTime)
    //     if (this.deliveryTime.split(" ")[1] == 'pm') {
    //       deliveryAddress.deliveryDate.setHours(
    //         Number.parseInt(this.deliveryTime.split(":")[0]) + 12);
    //     }
    //     else {
    //       deliveryAddress.deliveryDate.setHours(
    //         Number.parseInt(this.deliveryTime.split(":")[0])
    //       );
    //     }
    //     deliveryAddress.deliveryDate.setMinutes(
    //       Number.parseInt(this.deliveryTime.split(":")[1])
    //     );

    //     console.log(deliveryAddress)
    //     deliveryAddress.plotNo = this.plot;
    //     deliveryAddress.areaLocality = this.locality;
    //     deliveryAddress.stateCode = this.stateId;
    //     this.gstSaleInvcumBOS.customerDeliveryAddress = deliveryAddress;
    //     this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);

    //     var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();
    //     deliveryAddress.customerName = this.customerName;
    //     deliveryAddress.mobileNo = this.contactNo;
    //     deliveryAddress.pinCode = this.pincode;
    //     deliveryAddress.city = this.cityName;
    //     deliveryAddress.districtCode = this.districtId;
    //     deliveryAddress.houseAddress = this.address;
    //     deliveryAddress.email = this.email;
    //     deliveryAddress.plotNo = this.plot;
    //     deliveryAddress.areaLocality = this.locality;
    //     deliveryAddress.deliveryDate = this.deliveryDate;
    //     this.productOrderSummary.deliveryAddress = deliveryAddress;

    //     this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);

    //     this.createSetUpForm.patchValue({
    //       logInCustomerEmail: this.googleCustomer.email
    //     })
    //     console.log(this.createSetUpForm.value)
    //     this.customerDeliveryDetailsSubcription = this.addressService.insertDeliveryDetails(this.apiFactory.insertDeliveryDetails, this.createSetUpForm).subscribe((data) => {
    //       this.toastService.showSuccessToast("Saved Successfully");
    //     });
    //     this.dialog.open(GstinDialogComponent, {
    //       width: "350px",
    //     });
    //   }
    // });
  }

  onDeleteDeliveryDetails(deliveryDetail: any, index: number) {
    let headingMessage = "Are you sure want to delete the delivery details?";
    // const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
    //   height: '152px',
    //   width: '346px',
    //   data: { heading: headingMessage }
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     this.deactivateDeliveryDetailSubscription = this.addressService.deactivateDeliveryDetails(this.apiFactory.deactivateDeliveryDetails, deliveryDetail.refNo).subscribe((data) => {
    //       if (data) {
    //         this.toastService.showSuccessToast("Delivery details deleted successfully");
    //         this.createSetUpForm.reset();
    //         this.getDeliveryDetails();
    //         this.toogle = null;
    //       }
    //     });
    //   }
    // })
  }

  gstSaleInvcumBOS: GstSaleInvCumBosDto = new GstSaleInvCumBosDto();

  getWebOrders() {
    this.gstSaleInvcumBOS = this.productOrderSummaryService.getWebOrder();
  }

  gstSaleInvcumBOSArray: GstSaleInvCumBosDto[] = [];

  getWebOrdersArray() {
    this.gstSaleInvcumBOSArray = this.productOrderSummaryService.getWebOrderArray();
  }

  setDeliveryAddress() {
    var deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();

    deliveryAddress.refNo = this.createSetUpFormDelivery.get("id").value;
    deliveryAddress.contactName = this.createSetUpFormDelivery.get("customerName").value;
    deliveryAddress.contactMobile = this.createSetUpFormDelivery.get("contactNo").value;
    deliveryAddress.shippingPinCode = this.createSetUpFormDelivery.get("pincode").value;
    deliveryAddress.shippingCityCode = this.createSetUpFormDelivery.get("cityCode").value;
    deliveryAddress.shippingAddress = this.createSetUpFormDelivery.get("address").value;
    deliveryAddress.shippingPlotNo = this.createSetUpFormDelivery.get("plotNo").value;
    deliveryAddress.shippingLandMark = this.createSetUpFormDelivery.get("landMark").value;
    deliveryAddress.shippingStreet = this.createSetUpFormDelivery.get("street").value;
    deliveryAddress.email = this.createSetUpFormDelivery.get("email").value;
    deliveryAddress.stateCode = this.createSetUpFormDelivery.get("stateCode").value;
    deliveryAddress.districtCode = this.createSetUpFormDelivery.get("districtCode").value;
    deliveryAddress.deliveryDate = this.deliveryDate;
    deliveryAddress.latitude = this.createSetUpFormDelivery.get("latitude").value;
    deliveryAddress.longitude = this.createSetUpFormDelivery.get("longitude").value;
    deliveryAddress.stateName = this.stateList.filter(e => e.refNo == this.createSetUpFormDelivery.get("stateCode").value)[0]?.stateName;
    deliveryAddress.cityName = this.cityList.filter(e => e.id == this.createSetUpFormDelivery.get("cityCode").value)[0]?.name;;
    deliveryAddress.customerCode = this.googleCustomer.refNo;

    this.productOrderSummaryService.setCustomerDeliveryAddress(deliveryAddress);
    this.gstSaleInvcumBOS.customerDeliveryAddress = deliveryAddress;
    this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);
    this.productOrderSummary.deliveryAddress = deliveryAddress;
    this.productOrderSummaryService.setOrderSummary(this.productOrderSummary);
  }

  onlyNumbers(event: any) {
    event.target.value = event.target.value
      .replace(/[^0-9]/g, '')
      .slice(0, 10);

    this.createSetUpFormDelivery
      .get('contactNo')
      ?.setValue(event.target.value, { emitEvent: false });
  }

  closeDialog() {
    this.dialogRef.close();
    // this.dialogRef.close('delivery');
  }
}